function showCrisisAlert({ swalBox, orderNo }) {
    console.log("dsadasdasdasdsdsadasdasddsddddddd");
    swalBox(
        "warning",
        "Kriz Durumu Yönetimi",
        `${orderNo} numaralı sipariş için kriz durumu tespit edildi. Lütfen yeterli sayıda araç atayası yapınız.`,
        false,
        "Tamam"
    );
}

function showOrderNotFoundAlert({ swalBox }) {
    swalBox(
        "error",
        "Hata",
        "Belirtilen sipariş bulunamadı. Lütfen sayfayı yenileyip tekrar deneyiniz.",
        false,
        "Tamam"
    );
}

export const alerts = { showCrisisAlert, showOrderNotFoundAlert };